/**
 * MediaLightbox zoom state machine (pure, unit-tested — FR1-AC-004).
 *
 * 'fit' scales the media into the stage; a number is a percentage of the
 * natural size. Deterministic ladder so e2e/unit assertions are exact.
 */

export type MediaLightboxZoom = 'fit' | number;

export const ZOOM_STEPS = [25, 50, 75, 100, 150, 200, 300, 400] as const;

export function zoomIn(zoom: MediaLightboxZoom): MediaLightboxZoom {
  if (zoom === 'fit') return 100;
  const next = ZOOM_STEPS.find((step) => step > zoom);
  return next ?? ZOOM_STEPS[ZOOM_STEPS.length - 1];
}

export function zoomOut(zoom: MediaLightboxZoom): MediaLightboxZoom {
  if (zoom === 'fit') return 75;
  const lower = [...ZOOM_STEPS].reverse().find((step) => step < zoom);
  return lower ?? ZOOM_STEPS[0];
}

/** Double-click: fit ⇄ 100%. */
export function toggleZoom(zoom: MediaLightboxZoom): MediaLightboxZoom {
  return zoom === 'fit' ? 100 : 'fit';
}

export function zoomLabel(zoom: MediaLightboxZoom): string {
  return zoom === 'fit' ? 'Fit' : `${zoom}%`;
}
